import { BP, CONTENT_WIDTH, NAV_BREAKPOINT, PAGE_GUTTER, media } from "./breakpoints";

const theme = {
  BP,
  NAV_BREAKPOINT,
  PAGE_GUTTER,
  CONTENT_WIDTH,
  media,
};

export default theme;
